import module from 'empresa/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export default class EmpresaCuentaInformacionComponent {
  constructor ($q, $notify, $state, CatalogoBancos, CatalogoFirmantes, CatalogoMonedas, CatalogoSucursales, EmpresaCuentaInformacion) {
    this.$q = $q
    this.$notify = $notify
    this.$state = $state
    this.CatalogoBancos = CatalogoBancos
    this.CatalogoFirmantes = CatalogoFirmantes
    this.CatalogoMonedas = CatalogoMonedas
    this.CatalogoSucursales = CatalogoSucursales
    this.EmpresaCuentaInformacion = EmpresaCuentaInformacion
    this.idEmpresa = null
    this.idCliente = null
    this.idCuenta = null
    this.procesando = false
    this.catalogos = {
      bancos: [],
      estatus: [
        {id: '0', descripcion: 'Inactivo'},
        {id: '1', descripcion: 'Activo'},
        {id: '2', descripcion: 'Suspendido'},
      ],
      firmantes: [],
      monedas: [],
      sucursales: [],
      tiposFirmante: [
        {id: '001', descripcion: 'Individual'},
        {id: '002', descripcion: 'Mancomunada'},
      ],
    }
  }

  $onInit () {
    this.promise = this.$q.all([
      this.CatalogoBancos.get()
        .then((response) => (this.catalogos.bancos = orderBy(response.data, ['descripcion']))),
      this.CatalogoFirmantes.get()
        .then((response) => (this.catalogos.firmantes = orderBy(response.data, ['descripcion']))),
      this.CatalogoMonedas.get()
        .then((response) => (this.catalogos.monedas = orderBy(response.data, ['descripcion']))),
      this.CatalogoSucursales.get()
        .then((response) => (this.catalogos.sucursales = orderBy(response.data, ['descripcion']))),
      this.EmpresaCuentaInformacion.get(this.idEmpresa, this.idCuenta)
        .then((response) => (this.data = response.data)),
    ])
  }

  actualizar (form) {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    return this.EmpresaCuentaInformacion.put(this.idEmpresa, this.idCuenta, this.data)
      .then(() => (form.$setPristine()))
      .catch((response) => (this.error = response.data))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.$state.go('finances.cuentasBancarias.detalle.editar')
  }

  validarFirmante (n) {
    if (!this.data[`firmante_${n}`]) {
      this.data[`firmante_${n}`] = ''
      this.data[`firmante_${n}_tipo`] = '000'
    } else if (this.data[`firmante_${n}_tipo`] === '000') {
      this.data[`firmante_${n}_tipo`] = undefined
    }
  }
}

module.component('empresaCuentaInformacion', {
  controller: EmpresaCuentaInformacionComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCliente: '<',
    idCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuenta/informacion/component.js